export const ASPECT_RATIO = {
  "8_7": 1.142857,
  "7_8": 0.875,
  "16_9": 1.77777,
  "3_4": 0.75,
  "4_3": 1.33333,
  "1_1": 1,
  "2_1": 2,
}

export const MASKS = [
  '01_maska_mazok_1',
  '02_maska_krug_1',
  '03_maska_krug_2',
  '04_maska_mazok_2',
  '05_maska_pyatno_1',
  '06_maska_romb_1',
  // '07_maska_pyatno_2',
  // '08_maska_mazok_3',
  '09_maska_4-kvadrata',
  '10_maska_setka-vypuklaya',
  '11_maska_5-ugol',
  '12_maska_shit',
  '13_maska_kniga',
  '14_maska_shesterenka',
  '15_maska_klever',
  '16_maska_klen',
  '17_maska_kot',
  '18_maska_serdce',
  '19_maska_vog-kvadrat',
  '20_maska_kvadrat-ten',
  '21_maska_kvadrat-shtrih',
  '22_maska_kvadrat-skruglenny',
]

export const MAP_LAYER_TYPES = [
  { val: 'point', label: 'Место, точка (события, памятники)', score: 0 },
  { val: 'building', label: 'Здание, строение', score: 1 },
  { val: 'bridge', label: 'Мосты и путепроводы', score: 10 },
  { val: 'road_a', label: 'Дорога (уровень А, местного значения)', score: 2 },
  { val: 'road_b', label: 'Дорога (уровень Б, крупные артерии)', score: 3 },
  { val: 'spaces', label: 'Пространства (площади, промышленные зоны, комплексы строений)', score: 4 },
  { val: 'river', label: 'Река, ручей', score: 5 },
  { val: 'water', label: 'Водная поверхность (озеро, пруд, водохранилище, море)', score: 6 },
  { val: 'forest_park_area', label: 'Лесо-парковая зона', score: 7 },
  { val: 'locality', label: 'Населенный пункт', score: 8 },
  { val: 'area', label: 'Территория, область карты (лесной массив, область, провинция)', score: 9 },
  { val: 'country', label: 'Страна', score: 11 },
  { val: 'continent', label: 'Континент', score: 12 },
]
export const SHADOW_OPTIONS = [
  { value: 'none', label: "Нет" },
  { value: 'has', label: "Есть" },
]

export const LINE_WIDTH = [
  { value: 1, label: "1px" },
  { value: 2, label: "2px" },
  { value: 3, label: "3px" },
  { value: 4, label: "4px" },
]

export const SHOW_IMAGE_VARIANTS = [
  { value: 'show', label: "Показать" },
  { value: 'unshow', label: "Скрыть" },
]

export const ICON_COLORS = [
  { value: 'white', label: "Белый" },
  { value: "black", label: "Чёрный" },
  { value: "vistat", label: "Vistat" },
]

// ▬▬▬▬▬▬
export const BORDERS = [
  { value: 'none', label: "нет" },
  { value: "solid", label: "⸻" },
  { value: "dotted", label: "· · · · ·" },
  // { value: "shortdash", label: "------" },
  { value: "dashed", label: "‒ ‒ ‒" },
  // { value: "longdash", label: "— — —" },
  // { value: "dashdot", label: "Длинное тире-короткое тире" },
  // { value: "longdashdot", label: "Очень длинное тире - точка" },
  // { value: "longdashdotdot", label: "Длинное тире-точка-точка" },
  // { value: "shortdashdot", label: "- · - ·" },
  // { value: "shortdashdotdot", label: "- · ·" },
  // { value: "shortdot", label: "Точки через двойной интервал" },
]

export const BORDER_POSITIONS = [
  { value: 'none', label: "Нет" },
  { value: "all", label: "Со всех сторон" },
  { value: "bottom", label: "Снизу" },
  { value: "top-bottom", label: "Сверху-снизу" },
  { value: "left-right", label: "Слева-справа" },
  { value: "without-top", label: "Слева-справа и снизу" },
]

export const FIGURE_LINES = [
  // 'line-default',
  // 'line',
  'point-line-point',
  // 'left-arrow',
  'right-arrow',
  // 'left-arrow-right',
  // { value: null, label: 'Нет' },
  // { value: 'line', label: 'Линия' },
  // { value: 'point-line-point', label: 'Линия с точками' },
  // { value: 'left-arrow', label: 'Линия со стрелкой влево' },
  // { value: 'right-arrow', label: 'Линия со стрелкой вправо' },
  // { value: 'left-arrow-right', label: 'Линия со стрелками' },
]

export const FIGURE_START_POINTS = [
  'line-default',
  'left-arrow-fill',
  'left-arrow-stroke',
  'start-point-circle',
]

export const FIGURE_END_POINTS = [
  'line-default',
  'right-arrow-fill',
  'right-arrow-stroke',
  'end-point-circle',
]

export const BG_SELECT_VALUES = [
  { value: 'none', label: "нет" },
  { value: 'bg-image', label: "Изображение" },
  { value: 'image', label: "Фон" },
  { value: 'color', label: "Цвет" },
]

export const PALETTE_BG_SELECT_VALUES = [
  { value: 'none', label: "нет" },
  { value: 'color', label: "Цвет" },
  { value: 'palette', label: "Палитра" },
]

export const LOGO_SIZE = [
  { value: '30x20', label: "30x20" },
  { value: '45x30', label: "45x30" },
  { value: '60x40', label: "60x40" },
]

export const AUTHOR_FONT_SIZE = [
  { value: 12, label: "12px" },
  { value: 13, label: "13px" },
  { value: 14, label: "14px" },
  { value: 15, label: "15px" },
  { value: 16, label: "16px" },
]

export const NAME_FONT_SIZE = [
  { value: 18, label: "18px" },
  { value: 19, label: "19px" },
  { value: 20, label: "20px" },
  { value: 21, label: "21px" },
  { value: 22, label: "22px" },
]

export const FONT_WEIGHTS = [
  { value: 300, label: "light" },
  { value: 700, label: "bold" },
]

export const FONT_FAMILIES = [
  { value: 'Arial', label: "Arial" },
  { value: 'Formular', label: "Formular" },
  { value: 'Times New Roman', label: "Times New Roman" },
  { value: 'Georgia', label: "Georgia" },
  { value: 'Palatino', label: "Palatino" },
  { value: 'Palatino Linotype', label: "Palatino Linotype" },
  { value: 'Book Antiqua', label: "Book Antiqua" },
  { value: 'Courier New', label: "Courier New" },
  { value: 'Helvetica', label: "Helvetica" },
  { value: 'Verdana', label: "Verdana" },
  { value: 'Tahoma', label: "Tahoma" },
  { value: 'Trebuchet MS', label: "Trebuchet MS" },
  { value: 'Lucida Console', label: "Lucida Console" },
  { value: 'Comic Sans MS', label: "Comic Sans MS" },
  { value: 'Brush Script MT', label: "Brush Script MT" },
  { value: 'Impact', label: "Impact" },
]

export const BLOCK_POSITIONS = [
  { value: 'left', label: 'Слева' },
  { value: 'center', label: 'По центру' },
  { value: 'right', label: 'Справа' },
]
export const MENU_POSITIONS = [
  { value: 'top', label: 'Сверху' },
  { value: 'bottom', label: 'Снизу' },
]
export const MENU_BURGERS = [
  { value: 'always', label: 'Всегда' },
  { value: 'scroll', label: 'При прокрутке' },
]
export const BG_SIZES = [
  { value: 'attached', label: 'Растянуть, статика' },
  { value: 'cover', label: 'Растянуть, прокрутка' },
  { value: 'repeat', label: 'Замостить' },
]

export const DIRECTIONS = [
  { value: 'horizontal', label: "Горизонтально" },
  { value: 'vertical', label: "Вертикально" },
]

export const AXIS_ROTATE_DIRECTIONS = [
  { value: 0, label: "Горизонтально" },
  { value: 90, label: "Вертикально" },
  { value: 15, label: "Наклон влево" },
  { value: -15, label: "Наклон вправо" },
]

export const CONTAINER_WIDTHS = [
  { value: 'none', label: "100% экрана" },
  { value: '100%', label: "100% контейнера" },
  { value: '1200px', label: "1200px" },
  { value: '1000px', label: "1000px" },
  { value: '800px', label: "800px" },
  { value: '600px', label: "600px" },
]

export const LIST_COLORS = [
  "#FDAE49",
  "#F37D5F",
  "#BB7B7A",
  "#AE76A3",
  "#9686CF",
  "#758DE3",
  "#5CABEA",
  "#52B3D1",
  "#4AADB7",
  "#59BAAF",
  "#88C287",
  "#C1C570",
]

export const SHORT_LIST_COLORS = [
  "#ffadad",
  "#ffd6a5",
  "#fdffb6",
  "#caffbf",
  "#9bf6ff",
  "#a0c4ff",
  "#bdb2ff",
  "#ffc6ff",
]

export const MESSAGES = {
  'required': "Поле обязательное",
  'urlType': "Не является ссылкой",
}

// export const CHART_TYPES = [
//   'line_base',
//   'line_smooth',
//   'histogram_base',
//   'histogram_radius',
//   'histogram_horiz',
//   'histogram_horiz_radius',
//   'circle_base',
//   'circle_radius',
//   'funnel_base',
//   'treemap_base',
// ]

export const CHART_TYPES = {
  'line': { label: 'Линия', childrens: [{ name: 'line_base', label: 'базовая' }, { name: 'line_smooth', label: 'сглаженная' }] },
  'histogram': { label: 'Гистограмма', childrens: [{ name: 'histogram_base', label: 'базовая' }, { name: 'histogram_radius', label: 'скругленная' }, { name: 'histogram_horiz', label: 'горизонтальная базовая' }, { name: 'histogram_horiz_radius', label: 'горизонтальная скругленная' }] },
  'circle': { label: 'Круговая диаграмма', childrens: [{ name: 'circle_base', label: 'базовая' }, { name: 'circle_radius', label: 'скругленная' }] },
  'funnel': { label: 'Воронка', childrens: [{ name: 'funnel_base', label: 'базовая' }] },
  'Treemap': { label: 'Treemap', childrens: [{ name: 'treemap_base', label: 'базовая' }] },
}

export const DESIGN_VARIANTS = {
  'links_objects': [
    { id: "square", label: "Квадрат #1" },
    { id: "square-2", label: "Квадрат #1 v2" },
    { id: "blue", label: "Blue (6U)" },
    { id: "links_objects_default", label: "Minimalism" },
  ],
  'links_events': [
    { id: "links_events_default", label: "Flex" },
    { id: "links_events_line", label: "Line" },
  ],
  'facts': [
    { id: 'facts_default', label: "Gray-blue" },
    { id: 'green', label: "Green" },
    { id: 'white', label: "White" },
    { id: 'blue', label: "Light blue" },
    { id: 'color', label: "Color" },
    { id: 'minimalism', label: "Minimalism" },
  ],
  'tables': [
    { id: 'tables_default', label: "Borders" },
    { id: 'line', label: "Line" },
    { id: 'radius', label: "Rounded" },
  ],
  'tgbs': [
    { id: 'tgbs_default', label: "1 + 1" },
    { id: 'with-bg', label: "ТГБ с фоном" },
    { id: 'accent', label: "Акцент" },
  ],
  'links_images': [
    { id: 'links_images_minimalism', label: "Минимализм" },
    { id: 'default', label: "Круглая обводка" },
    { id: 'with-detail', label: "Квадрат 1+1" },
    { id: 'with-detail-new', label: "Квадрат 1+1 v2" },
    { id: 'with-detail-totop', label: "Стрелка вниз" },
  ],
  'links_icons': [
    { id: 'links_icons_minimalism', label: "Минимализм" },
    { id: 'default', label: "Круглая обводка" },
    { id: 'with-detail-icon', label: "Квадрат" },
    { id: 'with-detail-icon-totop', label: "Стрелка вниз" },
  ],
  'props': [
    { id: 'props_default', label: "Light" },
    { id: 'round', label: "Round" },
  ],
}

export const DEFAULT_ATTRS_SETTINGS_FOR_DESIGNS = {
  // Для изображений
  'links_images_minimalism': { icon_border: { color: '#d7d7d7' }, icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121' } },
  'default': { bg: { color: '#ffffff' }, icon_border: { palette: 'Pal007' }, icon_color: { color: 'vistat' }, text: { color: '#212121' }, first_block: { title_color: '#212121', block_border_color: '#212121', icon_border_color: '#212121', bg_color: '#b4d6f5', gradient_enabled: true, gradient_direction: 'bottom', gradient_shadow_direction: 'transparent' } },
  'with-detail': { bg: { color: '#00ffff', gradient_enabled: true, gradient_direction: 'bottom', gradient_shadow_direction: 'color' }, text: { color: '#212121' }, first_block: { title_color: '#ffffff', block_border_color: '#212121', icon_border_color: '#212121', bg_color: '#68adec' } },
  'with-detail-new': { bg: { color: '#00ffff', gradient_enabled: true, gradient_direction: 'bottom', gradient_shadow_direction: 'color' }, text: { color: '#212121' }, first_block: { title_color: '#ffffff', block_border_color: '#212121', icon_border_color: '#212121', bg_color: '#68adec' } },
  'with-detail-totop': { bg: { palette: 'Pal008' }, text: { color: '#212121' }, first_block: { title_color: '#212121', block_border_color: '#212121', icon_border_color: '#212121' } },

  // Для иконок
  'links_icons_minimalism': { icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121' } },
  'with-detail-icon': { bg: { palette: 'Pal017' }, icon_border: { palette: 'Pal002' }, icon_bg: { color: '#b4d6f5', gradient_enabled: true, gradient_direction: 'bottom', gradient_shadow_direction: 'transparent' }, icon_color: { color: 'vistat' }, text: { color: '#212121' }, first_block: { title_color: '#ffffff', block_border_color: '#212121', icon_border_color: '#212121', bg_color: '#68adec' } },
  'with-detail-icon-totop': { bg: { palette: 'Pal008' }, icon_border: { color: '#d7d7d7' }, icon_bg: { color: '#ffffff' }, icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121', block_border_color: '#212121', icon_border_color: '#212121', bg_color: '#68adec' } },
}

export function getDefaultAttrsSettingsForDesign(design) {
  return DEFAULT_ATTRS_SETTINGS_FOR_DESIGNS[design];
}

export const DEFAULT_TABLES_SETTINGS_FOR_DESIGNS = {
  'default': { icon_border: { palette: 'Pal007' }, icon_color: { color: 'vistat' }, text: { color: '#212121' }, first_block: { title_color: '#212121', bg_color: '#b4d6f5', gradient_enabled: true, gradient_direction: 'bottom', gradient_shadow_direction: 'transparent' } },
  'line': { icon_border: { palette: 'Pal007' }, icon_color: { color: 'vistat' }, text: { color: '#212121' }, first_block: { title_color: '#212121', bg_color: '#b4d6f5', gradient_enabled: true, gradient_direction: 'bottom', gradient_shadow_direction: 'transparent' } },
  'radius': { bg: { color: '#f5f5f5' }, icon_color: { color: 'black' }, text: { color: '#2f4f4f' }, first_block: { title_color: '#2f4f4f', bg_color: '#d7d7d7' } },
}

export function getDefaultTablesSettingsForDesign(design) {
  return DEFAULT_TABLES_SETTINGS_FOR_DESIGNS[design];
}

export const DEFAULT_FACTS_SETTINGS_FOR_DESIGNS = {
  'default': { bg: { palette: 'Pal002' }, icon_color: { color: 'white' }, text: { color: '#ffffff' }, first_block: { title_color: '#ffffff' } },
  'green': { bg: { palette: 'Pal003' }, icon_color: { color: 'white' }, text: { color: '#ffffff' }, first_block: { title_color: '#ffffff' } },
  'white': { bg: { color: '#ffffff' }, block_border: { color: '#b4d6f5' }, icon_color: { color: 'vistat' }, text: { color: '#212121' }, first_block: { title_color: '#212121', bg_color: '#ffffff' } },
  'blue': { bg: { palette: 'Pal004' }, icon_color: { color: 'vistat' }, text: { color: '#212121' }, first_block: { title_color: '#212121' } },
  'color': { block_border: { palette: 'Pal005' }, icon_border: { color: '#d7d7d7' }, icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121' } },
  'minimalism': { block_border: { palette: 'Pal005' }, icon_border: { color: '#d7d7d7' }, icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121', block_border_color: '#212121', icon_border_color: '#212121' } },
}

export function getDefaultFactsSettingsForDesign(design) {
  return DEFAULT_FACTS_SETTINGS_FOR_DESIGNS[design];
}

export const DEFAULT_PROPS_SETTINGS_FOR_DESIGNS = {
  'props_default': {
    bg: { palette: 'Pal001' },
    block_border: { color: null },
    icon_border: { color: '#E5F3FC' },
    icon_bg: { color: '#50ADFF' },
    icon_color: { color: 'white' },
    text: { color: '#212121' },
    mask: { name: '22_maska_kvadrat-skruglenny' },
    first_block: { title_color: 'rgba(0, 0, 0, 0.65)' },
  },
  'round': {
    bg: { palette: 'Pal001' },
    block_border: { color: null },
    icon_border: { color: '#E5F3FC' },
    icon_bg: { color: '#50ADFF' },
    icon_color: { color: 'white' },
    text: { color: '#212121' },
    mask: { name: '22_maska_kvadrat-skruglenny' },
    first_block: { title_color: 'rgba(0, 0, 0, 0.65)' },
  },
}

export function getDefaultPropsSettingsForDesign(design) {
  return DEFAULT_PROPS_SETTINGS_FOR_DESIGNS[design] || DEFAULT_PROPS_SETTINGS_FOR_DESIGNS['props_default'];
}

export const DEFAULT_EVENTS_SETTINGS_FOR_DESIGNS = {
  'default': { icon_border: { palette: 'Pal007' }, icon_bg: { color: '#ffffff' }, bg: { color: '#ffffff' }, icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121' } },
  'line': { icon_border: { palette: 'Pal007' }, icon_bg: { color: '#ffffff' }, bg: { color: '#ffffff' }, icon_color: { color: 'black' }, text: { color: '#212121' }, first_block: { title_color: '#212121' } },
}

export function getDefaultEventsSettingsForDesign(design) {
  return DEFAULT_EVENTS_SETTINGS_FOR_DESIGNS[design];
}

export function getDefaultThemeSettings(name, module, store) {
  const stylesList = store.state["property_templates"]["consts"].design
  if (name && stylesList) {
    return stylesList.find(el => el.id === name && el.module === module);
  }

  return { designs: [{}] }
}

export const QUOTES_SUBJECTS = [
  "Ад",
  "Алкоголь и вино",
  "Армия",
  "Бедность",
  "Бесчестье",
  "Библия",
  "Бизнес",
  "Бог",
  "Богатство",
  "Будущее",
  "Быт",
  "Вера и религия",
  "Верность",
  "Власть",
  "Война",
  "Воля",
  "Воровство",
  "Враги",
  "Время",
  "Время года",
  "Встреча",
  "Вымысел",
  "Герои и героизм",
  "Глупость и дураки",
  "Гнев",
  "Горы",
  "Государство",
  "Грех",
  "Действия",
  "Деньги",
  "Дети",
  "Добро",
  "Доверие",
  "Долг",
  "Дом",
  "Драгоценности",
  "Дружба",
  "Еда",
  "Жадность",
  "Желания",
  "Женщина",
  "Живопись и художники",
  "Животные",
  "Жизнь",
  "Здоровье и медицина",
  "Зло",
  "Знание",
  "Игра",
  "Изобретение",
  "Ирония",
  "Искусство",
  "История",
  "Книги",
  "Космос",
  "Красота",
  "Культура",
  "Лень",
  "Личность",
  "Логика",
  "Ложь",
  "Любовь",
  "Математика",
  "Месть",
  "Мечта",
  "Милость",
  "Мода",
  "Молодость",
  "Мораль",
  "Море",
  "Мужчина",
  "Музыка",
  "Наказание",
  "Настоящее",
  "Наука",
  "Недоверие",
  "Ненависть",
  "Неудача",
  "Новая жизнь",
  "Новые технологии",
  "Обиды",
  "Обман",
  "Общение",
  "Общество",
  "Одежда",
  "Одиночество",
  "Опыт",
  "Оружие",
  "Отдых",
  "Отношения",
  "Ошибки",
  "Память",
  "Перемены",
  "Победа",
  "Поиск",
  "Политика",
  "Помощь",
  "Поражение",
  "Пороки",
  "Правда и истина ",
  "Правители и начальники",
  "Предательство",
  "Преступление",
  "Прибыль",
  "Природа",
  "Прогресс",
  "Прошлое",
  "Психология",
  "Путешествия",
  "Путь",
  "Работа",
  "Рабы и слуги",
  "Рай",
  "Расставание",
  "Реальность",
  "Родина",
  "Родители",
  "Свобода",
  "Секреты и тайны",
  "Семья",
  "Сила",
  "Слабость",
  "Слава",
  "Слезы",
  "Слова",
  "Смерть",
  "Смысл жизни",
  "Совесть",
  "Сон",
  "Спор",
  "Спорт",
  "Старость",
  "Страх",
  "Стыд",
  "Судьба",
  "Судья",
  "Счастье",
  "Тайна",
  "Талант",
  "Творчество",
  "Театр и актеры",
  "Техника",
  "Трусость",
  "Удовольствие",
  "Ум и интеллект",
  "Успех",
  "Учение и образование",
  "Ученые",
  "Футуризм",
  "Характер",
  "Хитрость и коварство",
  "Цивилизация",
  "Человек",
  "Человечество",
  "Честность",
  "Честь",
  "Чувства",
  "Чудо",
  "Шанс и удача",
  "Эгоизм",
  "Юмор",
  "Язык",
]

export const STORAGE_PATH = `${process.env.BASE_URL_V2}/storage/d/`
export const BUILD_STORAGE_PATH = (block, id) => `${STORAGE_PATH}${block}/${id}`
export const STORAGE_IMAGE_PATH = `${process.env.BASE_URL_V2}/storage/d/materials/`
export const STORAGE_BACKGROUND_PATH = `${process.env.BASE_URL_V2}/storage/d/backgrounds/`
export const BUILD_STORAGE_IMAGE_PATH = (id) => `${STORAGE_IMAGE_PATH}${id}`
export const GENERAL_STORAGE_IMAGE_PATH = `${process.env.BASE_URL_V2}/storage/d/stored/`
export const BUILD_GENERAL_STORAGE_IMAGE_PATH = (id) => `${GENERAL_STORAGE_IMAGE_PATH}${id}`

export const INFO_GRAPHIC_COLORS = [
  { value: '#ffffff', label: 'Белый' },
  { value: '#f0f8ff', label: 'Синяя Элис' },
  { value: '#dbd7d2', label: 'Лесной волк' },
  { value: '#a0a0a4', label: 'Серый нейтральный' },
  { value: '#646b63', label: 'Мышино-серый' },
  { value: '#2f4f4f', label: 'Аспидно-серый' },
  { value: '#212121', label: 'Чёрно-коричневый' },
  { value: '#f9f9f9', label: 'Почти белый' },
  { value: '#f5f5f5', label: 'Дымчато-белый' },
  { value: '#d7d7d7', label: 'Светлый серый' },
  { value: '#a5a5a5', label: 'Бело-алюминиевый' },
  { value: '#696969', label: 'Тусклый серый' },
  { value: '#3c3c3c', label: 'Темно-серый' },
  { value: '#000000', label: 'Чёрный' },
  { value: '#f5fffa', label: 'Мятно-кремовый' },
  { value: '#e0fff0', label: 'Зеленый в небесах' },
  { value: '#7fffd4', label: 'Аквамариновый' },
  { value: '#66cdaa', label: 'Умеренный аквамариновый' },
  { value: '#20b2aa', label: 'Светлое зелёное море' },
  { value: '#008080', label: 'Бирюзовая окраска птицы чирок' },
  { value: '#013220', label: 'Глубокий тёмно-зелёный' },
  { value: '#98fb98', label: 'Бледный зелёный' },
  { value: '#00fa9a', label: 'Умеренный весенний зелёный' },
  { value: '#00ff7f', label: 'Весенне-зелёный' },
  { value: '#00ff00', label: 'Зеленый (лайм)' },
  { value: '#32cd32', label: 'Лаймово-зелёный' },
  { value: '#008000', label: 'Зелёный классический' },
  { value: '#006400', label: 'Очень тёмный лимонно-зеленый' },
  { value: '#9acd32', label: 'Жёлто-зелёный' },
  { value: '#3cb371', label: 'Умеренно-зелёное море' },
  { value: '#2e8b57', label: 'Зелёное море' },
  { value: '#6b8e23', label: 'Нежно-оливковый' },
  { value: '#228b22', label: 'Лесной зелёный' },
  { value: '#808000', label: 'Оливковый' },
  { value: '#556b2f', label: 'Темные оливки' },
  { value: '#fffff0', label: 'Слоновая кость' },
  { value: '#fffacd', label: 'Лимонно-кремовый' },
  { value: '#FFF9C4', label: 'Светлый лимонно-кремовый' },
  { value: '#ffefd5', label: 'Побег папайи' },
  { value: '#F0E68C', label: 'Светлый хаки' },
  { value: '#bdb76b', label: 'Тёмный хаки' },
  { value: '#8F9779', label: 'Артишок оливково-желтый' },
  { value: '#FFFFE0', label: 'Светло-жёлтый' },
  { value: '#FFFDD0', label: 'Кремово-жёлтый' },
  { value: '#FFEE58', label: 'Кукуруза в зелени' },
  { value: '#ffff00', label: 'Жёлтый' },
  { value: '#FFDB58', label: 'Горчичный' },
  { value: '#ffd700', label: 'Золотой' },
  { value: '#CC9900', label: 'Тёмно-желтый' },
  { value: '#FFE4B5', label: 'Мокасиновый' },
  { value: '#ffdab9', label: 'Тёмно-персиковый' },
  { value: '#FDD835', label: 'Теплое солнце' },
  { value: '#F9A825', label: 'Золотой мед' },
  { value: '#FFB347', label: 'Пастельный апельсин' },
  { value: '#FF8C00', label: 'Тёмно-оранжевый' },
  { value: '#CC5500', label: 'Жжёный апельсин' },
  { value: '#f5f5dc', label: 'Бежевый' },
  { value: '#d2b48c', label: 'Цвет загара' },
  { value: '#d2691e', label: 'Шоколадный' },
  { value: '#ff4f00', label: 'Сигнальный оранжевый' },
  { value: '#ff0000', label: 'Красный' },
  { value: '#a0522d', label: 'Сиена' },
  { value: '#a52a2a', label: 'Коричнево-бордовый' },
  { value: '#faf0e6', label: 'Льняной' },
  { value: '#ffa500', label: 'Оранжевый' },
  { value: '#e9967a', label: 'Тёмно-лососёвый' },
  { value: '#f08080', label: 'Светло-коралловый' },
  { value: '#cd5c5c', label: 'Индийский красный' },
  { value: '#dc143c', label: 'Малиновый' },
  { value: '#800000', label: 'Коричнево-малиновый' },
  { value: '#FFF8F0', label: 'Легкий бежевый' },
  { value: '#E6D5B8', label: 'Светлый песок' },
  { value: '#BC8F5F', label: 'Кофе с молоком' },
  { value: '#6E4B1F', label: 'Глубокий коричневый' },
  { value: '#5D4037', label: 'Темный шоколад' },
  { value: '#4E342E', label: 'Терракота двойного обжига' },
  { value: '#3E2723', label: 'Горький шоколад 80%' },
  { value: '#fffafa', label: 'Белоснежный' },
  { value: '#fff0f5', label: 'Розово-лавандовый' },
  { value: '#ffc0cb', label: 'Розовый' },
  { value: '#bc8f8f', label: 'Розово-коричневый' },
  { value: '#db7093', label: 'Лиловый' },
  { value: '#fc0fc0', label: 'Ярко-розовый' },
  { value: '#ff1493', label: 'Глубокий розовый' },
  { value: '#f0ffff', label: 'Небесная лазурь' },
  { value: '#b0e0e6', label: 'Пыльный голубой' },
  { value: '#00bfff', label: 'Морозное небо' },
  { value: '#42aaff', label: 'Голубой' },
  { value: '#7b68ee', label: 'Умеренный аспидно-синий' },
  { value: '#0000ff', label: 'Синий' },
  { value: '#00008b', label: 'Тёмный ультрамариновый' },
  { value: '#00ffff', label: 'Циан, цвет морской волны' },
  { value: '#48d1cc', label: 'Умеренно-бирюзовый' },
  { value: '#87ceeb', label: 'Городское небо' },
  { value: '#1e90ff', label: 'Защитно-синий' },
  { value: '#4169e1', label: 'Королевский синий' },
  { value: '#483d8b', label: 'Тёмный аспидно-синий' },
  { value: '#191970', label: 'Полуночный чёрный' },
  { value: '#f8f8ff', label: 'Призрачно-белый' },
  { value: '#ee82ee', label: 'Розово-фиолетовый' },
  { value: '#ff00ff', label: 'Маджента' },
  { value: '#ba55d3', label: 'Умеренный цвет орхидеи' },
  { value: '#9400d3', label: 'Тёмно-фиолетовый' },
  { value: '#800080', label: 'Пурпурный' },
  { value: '#4b0082', label: 'Индиго' },
  { value: '#f0f7fd', label: 'Белый Элис' },
  { value: '#b4d6f5', label: 'Светло-синий иней' },
  { value: '#68adec', label: 'Нежный василек' },
  { value: '#328fe5', label: 'Vistat' },
  { value: '#135897', label: 'Ночной капри' },
  { value: '#0a2c4b', label: 'Горечавка глубокая синяя' },
  { value: '#02090f', label: 'Темно-синий янтарь' },
]
